import { ParallaxController } from 'parallax-controller';

export default function Fullpage(parallaxConf) {


    const runParallax = () => {
        if(window.innerWidth < 768 || !parallaxConf)  {
            return;
        } else {
            setParallax(parallaxConf);
        }
    }
    
    document.addEventListener('DOMContentLoaded', () => {
       runParallax();
    });

    window.addEventListener('resize', () => {
       runParallax();
    });
}
  
function setParallax(parallaxConf) {

    if(!parallaxConf.container) return;
    if(!parallaxConf.elements) return;
    if(!parallaxConf.scrollAxis) parallaxConf.scrollAxis = 'y';

    let container = null;
    if(parallaxConf.container.startsWith('#') || parallaxConf.container.startsWith('.')) {
        container = document.querySelector(parallaxConf.container);
    } else {
        container = document.getElementById(parallaxConf.container);
    }

    if(!container) return;

    let scene = ParallaxController.init({
        scrollAxis: parallaxConf.scrollAxis,
        container,
    });

    parallaxConf.elements.forEach(subEl => {
        var elObj = container.querySelector(subEl.selector);
        if(!elObj) return;
        var props = subEl.axis === 'horizontal' ? { translateX: [subEl.start, subEl.end] } : { translateY: [subEl.start, subEl.end] };
        scene.createElement({
            el: elObj,
            props: props,
        });
    }); 

    window.addEventListener('resize', () => {
        if(window.innerWidth < 768) {
            scene.destroy();
        }
     });
    

}

function setResponsiveFonts(selector = '.fullpage .responsive-font') {
    
    const elements = document.querySelectorAll(selector);
    if(!elements) return;

    elements.forEach((element) => {
        setFontSize(element);
    });

    window.addEventListener('resize', () => {
        elements.forEach((element) => {
        setFontSize(element);
        });
    });
}

function setFontSize(element) {
    let fontSize = calculateFontSize(element);
    let content = element.querySelector('.content');
    if(!content) return;
    content.style.fontSize = `${fontSize}px`;
}

function calculateFontSize(element) {
    let rect = element.getBoundingClientRect();
    let pixels = rect.width * rect.height;
    let characters =  element.innerText.length;
    let ratio = pixels / characters;
    let height = Math.sqrt(ratio);
    let fontSize = Math.round(height / 1.4);
    return fontSize;
}